import { Button } from 'components/Button';
import Text from 'components/Text/Text';
import FormInputText from 'components/modules/form/FormInputText';
import FormTextArea from 'components/modules/form/FormTextArea';
import FormUpload from 'components/modules/form/FormUpload';
import { openai } from 'config/openAi';
import { Form, useFormikContext } from 'formik';
import { useState } from 'react';

function GenerateLogo({ type }) {
    const { setValues, values, setFieldValue, handleSubmit } = useFormikContext();

    const [isGenerated, setIsGenerated] = useState(false);
    const [loading, setLoading] = useState(false);

    const generateImage = async () => {
        setLoading(true);

        try {
            const res = await openai.createImage({
                prompt: values.logoDesc,
                n: 1,
                size: '512x512',
            });

            setValues({
                logoDesc: values.logoDesc,
                imgLogo: {
                    preview: res.data.data[0].url,
                },
            });

            setLoading(false);
            setIsGenerated(true);
        } catch (error) {
            setLoading(false);
        }
    };

    return (
        <Form className="flex flex-col gap-5">
            <Text size="14">Please describe the image you would like to see on background.</Text>

            <FormInputText name="logoDesc" placeholder="Description" />

            <FormUpload loading={loading} className="h-[345px]" readOnly name="imgLogo" />

            {isGenerated ? (
                <div className="flex flex-row gap-5">
                    <Button
                        disabled={loading}
                        color="secondary"
                        onClick={generateImage}
                        className={'flex-1'}
                        type="button"
                    >
                        Regenerate
                    </Button>
                    <Button disabled={loading} onClick={handleSubmit} className={'flex-1'} type="button">
                        Use
                    </Button>
                </div>
            ) : (
                <div className="flex flex-row gap-5">
                    <Button disabled={loading} onClick={generateImage} className={'flex-1'} type="button">
                        Generate
                    </Button>
                </div>
            )}
        </Form>
    );
}

export default GenerateLogo;
